<template lang="pug">
pr-wrapper.d-flex.align-items-end(fs, v-nv:scope="'chromecast'", nv-exit-protect, @nv-exit.native="close", @nv-back.native="close")
  .chromecast.w-100(v-visible="showConnection")
    pr-wrapper.chromecast-hero.d-flex.align-items-center(bg) 
      |
      .content-wrapper
        .content
          pr-text(size="medium", weight="semibold") {{ $t("Google Chromecast") }}<br>
          pr-text(size="medium") {{ $t("Ready to connect!") }}
          pr-text.text-muted.pt-2 {{ $t("Please follow the instructions to use the Chromecast") }}
    pr-wrapper.chromecast-ssid.d-flex.flex-column.justify-content-center(reverse, bg)
      .ssid_wrapper
        pr-text {{ $t("Connect to Wi-Fi") }} <b>@{{ ssid || $t("Not available") }}</b>
        .content-wrapper.d-flex.pt-4
          .content.flex-grow-1.d-flex.flex-column.justify-content-center
            pr-text(weight="light", size="small") {{ $t("SSID (wi-fi) password") }}:
            pr-text(weight="semibold") {{ password || $t("Not available") }}
            pr-text.mt-3(weight="semibold") {{ $t("Alternatively, just scan QR code") }}
          .image
            img.qrcode(:src="qrcode", v-show="qrcode", v-nv)
    pr-wrapper.chromecast-help.d-flex.align-items-end(bg)
      .content-wrapper.row.no-gutters
        .image.col.col-auto
          img(width="230", src="@/assets/images/chromecast_device.png")
        .content.col.d-flex.flex-column.justify-content-center.pl-4
          pr-text.text-muted.mb-2(size="small") {{ $t("Ready to use!") }}
          pr-text {{ $t("Open your favorite application and tap to chromecast icon!") }}
</template>

<script>
export default {
  name: "chromecast",
  data() {
    return {
      ssid: null,
      password: null,
      qrcode: null,
      showConnection: false
    }
  },
  async activated() {
    this.showConnection = true

    const status = await __.device.isSoftAPEnabled(),
      behaviour = __.device.softAPState()

    if (!status && behaviour === 1) await __.device.enableSoftAP()

    const { ssid, password } = await __.device.getSoftAP()
    this.ssid = ssid
    this.password = password
    this.qrcode = await __.api.get.softap({ ssid, password }).then(res => res?.qr)

    await this.$nextTick()
    _$.nav.changeScope("chromecast")
    __.platform.background(["/v2/assets/images/cast/cast_1.jpg", "/v2/assets/images/cast/cast_2.jpg", "/v2/assets/images/cast/cast_3.jpg"])
  },
  async deactivated() {
    const behaviour = __.device.softAPState()
    if (behaviour !== 2) __.device.disableSoftAP()
  },
  mounted() {
    _$.nav.sync("chromecast")
  },
  methods: {
    close() {
      __.platform.go()
    }
  }
}
</script>

<style lang="scss" scoped>
.chromecast {
  display: flex;

  .chromecast-hero {
    width: 25%;
    padding: 2rem 3.5rem 2rem 2rem;
  }

  .chromecast-ssid {
    flex-grow: 1;

    .ssid_wrapper {
      padding: 2rem;
    }
  }
  .chromecast-help {
    padding: 1rem 1rem 0 2rem;
    width: 40%;
  }

  .content-wrapper {
    img.qrcode {
      width: 120px;
    }
  }
}
</style>
